export default "__VITE_ASSET__gYzEwNco__"